import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { socialMediaServices } from '../services/socialMedia.service';

export const useSocialMediaLinks = (filters) => {
  return useQuery({
    queryKey: ['social-media', filters],
    queryFn: () => socialMediaServices.getSocialMediaLinks(filters),
    staleTime: 5 * 60 * 1000,
  });
};

export const useAddSocialMediaLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => socialMediaServices.addSocialMediaLink(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['social-media'] });
    },
  });
};

export const useUpdateSocialMediaLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => socialMediaServices.updateSocialMediaLink({ id, data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['social-media'] });
    },
  });
};

export const useDeleteSocialMediaLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => socialMediaServices.deleteSocialMediaLink(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['social-media'] });
    },
  });
};